import {MenuInfo} from "ant-design-vue/lib/menu/src/interface";
import {openWindow} from "@/utils";
import {DOC_URL} from "@/settings/siteSetting";
import {ref} from "vue";
import {openUrl} from "xmgoing-utils";
import SysConfigUtils from "@/utils/sysConfigUtils";

type MenuEvent =
  | 'xmAiCenter'
  | 'otherLogin'
  | 'logout'
  | 'doc'
  | 'lock'
  | 'portalSetting'
  | 'modPwd'
  | 'tenant'
  | 'kit'
  | 'kitCm'
  | 'seal'
  | 'userInfo'
  | 'sso'
  | 'IdentityCertification';

export function userUserDropHook({userStore, router, openModal}) {

  const portalSettingFlag = ref(false);

  const modPwdFlag = ref(false);

  //  login out
  function handleLoginOut() {
    userStore.confirmLoginOut();
  }

  //身份信息认证
  function openIdentityCertification() {
    router.push({
      path: '/xm-runing-extend/inentity-certification',
    });
  }

  // open doc
  function openDoc() {
    openWindow(DOC_URL);
  }

  //打开首页设置
  function openPortalSetting() {
    portalSettingFlag.value = !portalSettingFlag.value;
  }

  //修改密码窗口
  function openModPwd() {
    modPwdFlag.value = !modPwdFlag.value;
  }

  function handleLock() {
    openModal(true);
  }


  function handleMenuClick(e: MenuInfo) {
    switch (e.key as MenuEvent) {
      case 'logout':
        handleLoginOut();
        break;
      case 'doc':
        openDoc();
        break;
      case 'userInfo':
        router.push({path: '/xm-runing-extend/userMg'});
        break;
      case 'lock':
        handleLock();
        break;
      case 'portalSetting':
        openPortalSetting();
        break;
      case 'modPwd':
        openModPwd();
        break;
      // case 'tenant':
      //   tenantRef.value.setVisible(true);
      //   break;
      case 'kit':
        router.push({path: '/xm-runing-extend/chargeableOrder'});
        break;
      case 'kitCm':
        router.push({path: '/xm-runing-extend/chargeableOrder/orderPay'});
        break;
      case 'seal':
        router.push({path: '/xm-runing-extend/seal/sealList'});
        break;
      case 'systemVersion':
        router.push({path: '/xm-runing-extend/systemVersion'});
        break;
      case 'xmAiCenter':
        const params = {};
        params["sessionId"] = sessionStorage.getItem("sessionId");
        params["devPortal"] = location.host.split(":")[1];
        params["scenario"] = true;
        window.open(openUrl(
          SysConfigUtils.xmErp + `/xm-erp/aiCenter`,
          params
        ))
        break;
      case 'IdentityCertification':
        openIdentityCertification();
        break;



      case 'sso':

    }
  }

  return {
    modPwdFlag,
    portalSettingFlag,
    handleMenuClick
  }
}
